export default {
  example: {
    zh: '例子：',
    en: 'example: ',
  },
  keyWord: {
    zh: '关键字',
    en: 'keyWord',
  },
  // 数据类型
  dataType: {
    zh: '数据类型',
    en: 'Data type',
  },
  bigint: {
    zh: '长整型',
    en: 'The int type',
  },
  float: {
    zh: '浮点型',
    en: 'The float type',
  },
  string: {
    zh: '文本值，由 Unicode 字符组成',
    en: 'Text values, comprised of Unicode characters',
  },
  datetime: {
    zh: '时间类型',
    en: "Datatime type - Currently it's not supported yet",
  },
  boolean: {
    zh: '布尔类型',
    en: 'The boolean type, the value could be true or false',
  },
  array: {
    zh: '数组类型，可以是简单数据或结构类型(#1 - #5 和 #7)中的任何类型',
    en: 'The array type, can be anyßtypes from simple data or struct type (#1 - #5, and #7)',
  },
  struct: {
    zh: '复杂类型，名称/值对的集合,值必须是受支持的数据类型',
    en: 'The complex type. Set of name/value pairs.\nValues must be of supported data type',
  },
}
